import React from "react";
import CourierDispatch from "../../../../components/CourierDispatch/index";

const OrderDispatchForm = (props) => {
  return <CourierDispatch {...props} />;
};

export default OrderDispatchForm;
